<template>
  <div class="slideCharts">
    <!-- <div class="function">
      <div  class="">统计函数：{{centerTitle}}</div>
      <div  class="">产品名称：{{productName}}</div>
    </div> -->
    <emptyShow v-if="!hasData"></emptyShow>
    <div class="chartBox">
      <div ref="myCharts" class="chartBox_d"></div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
import emptyImg from '@img/empty.png'
// import resize from "@/mixins/resize";
import emptyShow from '@/components/empty_view'
// import { eventBus } from '@/utils/eventBus'
require('echarts/theme/macarons')
export default {
  props: ['data', 'refresh', 'title', 'unitName', 'centerTitle', 'productName'],
  name: 'SiderCharts',
  // mixins: [resize],
  components: {
    emptyShow
  },
  data () {
    return {
      mycharts: null,
      chartData: {
        date: [],
        series: []
      },
      emptyImg: emptyImg
    }
  },
  mounted () {
    if (this.data && this.data.xData) {
      this.chartData.date = this.data.xData
      this.chartData.series = this.data.series
      this.initEcharts()
    }
  },
  computed: {
    hasData () {
      return (this.data && this.data.xData && this.data.xData.length > 0)
    }
  },
  watch: {
    refresh () {
      console.log('refresh变化了')
      this.refreshChart()
    }
    // data: {
    //   deep: true,
    //   handler () {
    //     console.log('====================================')
    //     console.log('data数据变化')
    //     console.log('====================================')
    //     this.chartData.date = this.data.xData
    //     this.chartData.price = this.data.yData
    //     this.initEcharts()
    //     this.isRequestNext = false
    //   }
    // }
  },
  created () {
    // eventBus.$on('refresh-chart', this.refreshChart)
  },
  methods: {
    // mock data
    refreshChart () {
      console.log('调用了refreshChart')
      this.chartData.date = this.data.xData
      this.chartData.series = this.data.series
      this.initEcharts()
    },
    initEcharts () {
      this.mycharts = echarts.init(this.$refs.myCharts, 'macarons')
      this.mycharts.clear()// 清除后重新绘制
      this._setOption(this.chartData, true)
      const that = this
      this.mycharts.on('datazoom', function (params) {
        if (params.batch[0].end === 100) { // 证明拉到底了，请求下一页
          console.log('请求下一页')
          that.$emit('next-page')
        }
        console.log('触发的params：', params)
      })
    },
    _setOption (chartData) {
      this.mycharts.setOption({
        title: {
          // text: '商品价格变动图',
          left: '16'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              background: '#6a7985'
            }
          }
        },
        grid: { // 控制图表距离外框的间距
          top: '30',
          left: '24',
          right: '50',
          bottom: '40',
          containLabel: true
        },
        legend: { // 图例组件
          right: 20 // 右侧偏移量
          // data: ['设备数量']
        },
        xAxis: [
          {
            name: '时间',
            type: 'category',
            boundaryGap: false,
            data: chartData.date
          }
        ],
        yAxis: [
          {
            name: '数值', /// this.unitName || '台',
            type: 'value',
            boundaryGap: [0, '100%']
          }
        ],
        dataZoom: [
          {
            type: 'inside',
            start: 0,
            end: 99
          },
          {
            start: 0,
            end: 99,
            handleSize: '80%',
            handleStyle: {
              color: '#fff',
              shadowBlur: 3,
              shadowColor: 'rgba(0, 0, 0, 0.6)',
              shadowOffsetX: 2,
              shadowOffsetY: 2
            },
            bottom: 0
          }
        ],
        series: chartData.series
        // [
        //   {
        //     name: this.title || '设备数量',
        //     type: 'line',
        //     areaStyle: {
        //       color: '#55a8fd',
        //       opacity: 0.3
        //     },
        //     itemStyle: {
        //       color: '#55a8fd'
        //     },
        //     lineStyle: {
        //       color: '#55a8fd'
        //     },
        //     smooth: true,
        //     data: chartData.price,
        //     animationDuration: 2800,
        //     animationEasing: 'quadraticOut'
        //   }
        // ]
      })
    }
  }
}
</script>
<style lang="less" scoped>
.slideCharts {
  height: 100%;
  position: relative;
   .function{
      position: absolute;
      right: 20px;
      top: 20px;
      font-size: 20px;
    }
}
.chartBox {
  // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  background: #fff;
  height: 100%;
  .chartBox_d {
    height: 100%;
  }
}
</style>
